import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import Api from "../../../../lib/componentApi";
import getRegularPlaceData from "../../../../lib/getRegularPlaceData";
import validateForm, { formErrorsMessage } from "../../../../lib/validateForm";
import getAppErrors from "../../../../lib/appErrors";
import mixpanel from "../../../../lib/mixPanel";

import Submit from "../../../../components/Users/Addresses/Submit";
import ErrorSection from "../../../../components/Common/AppErrors";

class AddressesSubmit extends Component {
  constructor(props, context) {
    super(props, context);
    let address = props.address || {};
    if (!address.tips) address.tips = "";
    if (!address.fullName)
      address.fullName = `${props.firstName} ${props.lastName}`;
    const {
      addressLine1,
      postalCode,
      flatNumber
    } = formErrorsMessage.submitAddress;
    const formErrors = {};
    if (!address.addressLine1) {
      formErrors.addressLine1 = addressLine1;
    }
    if (!address.postalCode) {
      formErrors.postalCode = postalCode;
    }
    if (!address.flatNumber) {
      formErrors.flatNumber = flatNumber;
    }

    this.state = {
      ...address,
      showErrors: false,
      checkOut: !!props.checkOut,
      userAddressId: address.id || "",
      formErrors,
      error: null,
      active: !!(
        address &&
        address.addressLine1 &&
        address.postalCode &&
        address.flatNumber
      ),
      iconId: 1,
      localAddress:
        // eslint-disable-next-line
        (__isBrowser__ &&
          localStorage.getItem("deliveryDetails") &&
          JSON.parse(localStorage.getItem("deliveryDetails"))) ||
        ""
    };
  }

  componentDidMount() {
    const { checkOut, localAddress, formErrors } = this.state;
    if (checkOut) {
      if (localAddress) {
        const { routeName, postalCode, addressLine2, flatNumber } =
          localAddress || "";
        if (routeName) {
          formErrors.addressLine1 = "";
        }
        if (postalCode) {
          formErrors.postalCode = "";
        }
        if (flatNumber) {
          formErrors.flatNumber = "";
        }
        this.setState({
          addressLine1: routeName,
          postalCode: postalCode,
          addressLine2: addressLine2,
          flatNumber: flatNumber,
          formErrors
        });
      }
    }
  }

  isValid = () => {
    const { postalCode, addressLine1, flatNumber } = this.state;
    const errors = Object.values(this.state.formErrors).filter(Boolean);
    if (postalCode && addressLine1 && flatNumber && !errors.length) {
      return true;
    } else {
      this.setState(
        {
          showErrors: true
        },
        () => {
          return false;
        }
      );
    }
  };
  onSubmit = event => {
    event.preventDefault();
    const isValid = this.isValid();
    if (isValid) {
      const { handleCloseSection, handleCloseError } = this.props;
      let {
        title,
        postalCode,
        addressLine1,
        addressLine2,
        flatNumber,
        tips,
        userAddressId,
        fullName,
        checkOut,
        iconId
      } = this.state;
      if (!title || typeof title !== "string") {
        title = "";
      }
      if (!tips || typeof tips !== "string") {
        tips = "";
      }
      let apiUrl = (userAddressId && "/address/edit") || "/address/new";
      Api.post(
        `/api${apiUrl}`,
        {
          title: title,
          postalCode,
          addressLine1,
          addressLine2: addressLine2,
          flatNumber,
          tips: tips,
          userAddressId,
          fullName,
          addressIconID: iconId || 1
        },
        (response, errors) => {
          if (errors) {
            if (errors === 503) {
              this.setState(() => {
                throw errors;
              });
            } else {
              console.log(errors);
            }
          } else if (response.code) {
            const errorMessage = getAppErrors(response.code);
            this.setState({
              error: (errorMessage && errorMessage.message) || response.message,
              active: false
            });
          } else {
            mixpanel.track("Add New Address", {
              _title: !!title,
              _postCode: postalCode
            });
            if (checkOut) {
              const addressId = response.id;
              Api.post(
                "/api/product/set/address",
                { addressId },
                (response, errors) => {
                  if (errors) {
                    if (errors === 503) {
                      this.setState(() => {
                        throw errors;
                      });
                    } else {
                      console.log(errors);
                    }
                  } else if (response.code) {
                    //1822 numaralı kodu takip et !
                    handleCloseError(event, "newAddress", response.code);
                  } else {
                    if (response.status) {
                      if (handleCloseSection) {
                        handleCloseSection("newAddress");
                      } else {
                        window.location.href = "/checkout";
                      }
                    }
                  }
                }
              );
            } else {
              handleCloseSection(response.id);
            }
          }
        }
      );
    }
  };
  handleSelectPlace = async place => {
    const { formErrors } = this.state;
    const {
      postalCode,
      routeName,
      addressLine2,
      flatNumber
    } = await getRegularPlaceData(place.address);
    const active = !!(routeName && postalCode);
    if (routeName) {
      formErrors.addressLine1 = "";
    }
    if (postalCode) {
      formErrors.postalCode = "";
    }
    if (flatNumber) {
      formErrors.flatNumber = "";
    }
    this.setState({
      addressLine1: routeName,
      addressLine2,
      postalCode,
      flatNumber,
      formErrors,
      active
    });
  };
  handleChange = event => {
    const input = event.target.id;
    const inputValue = event.target.value;
    this.setState(
      {
        [input]: inputValue,
        showErrors: false
      },
      () => {
        const currentState = { [input]: this.state[input] };
        const inputError = validateForm(currentState, "submitAddress");
        const { formErrors } = this.state;
        formErrors[input] = inputError;
        this.setState({ formErrors }, () => {
          const { addressLine1, postalCode, flatNumber } = this.state;
          const errors = Object.values(this.state.formErrors).filter(Boolean);
          if (addressLine1 && postalCode && flatNumber && !errors.length) {
            this.setState({ active: true });
          } else {
            this.setState({ active: false });
          }
        });
      }
    );
  };
  onCloseErrorSection = () => {
    this.setState({
      error: null
    });
  };
  handleChangeIcon = iconId => {
    this.setState({
      iconId
    });
  };

  render() {
    const { handleCloseSection } = this.props;
    const {
      title,
      postalCode,
      addressLine1,
      addressLine2,
      flatNumber,
      tips,
      addManually,
      checkOut,
      formErrors,
      active,
      error,
      showErrors
    } = this.state || "";
    return (
      (error && (
        <ErrorSection onClickClose={this.onCloseErrorSection} message={error} />
      )) || (
        <Submit
          title={title}
          postalCode={postalCode}
          addressLine1={addressLine1}
          addressLine2={addressLine2}
          flatNumber={flatNumber}
          tips={tips}
          checkOut={checkOut}
          handleSubmit={this.onSubmit}
          handleChange={this.handleChange}
          handleSelectPlace={this.handleSelectPlace}
          addManually={addManually}
          formErrors={formErrors}
          active={active}
          handleCloseSection={handleCloseSection}
          showErrors={showErrors}
          handleChangeIcon={this.handleChangeIcon}
        />
      )
    );
  }
}

export default withRouter(AddressesSubmit);
